<template>
  <v-container>
    <p class="step-title">{{ $t('rdvStep.title') }}</p>
    <HfrCard>
      <v-form ref="rdvForm">
        <v-menu
          ref="menuDate"
          v-model="menuDate"
          :return-value.sync="formattedRdvDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              ref="dateField"
              v-model="formattedRdvDate"
              :label="$t('rdvStep.date')"
              prepend-icon="mdi-calendar"
              readonly
              filled
              v-bind="attrs"
              class="required"
              :rules="[rules.required, validateRangeDate]"
              v-on="on" />
          </template>
          <v-date-picker
            v-model="form.rdvDate"
            :active-picker.sync="activeRdvDatePicker"
            :min="minDate"
            locale="fr-CH"
            :first-day-of-week="1"
            @blur="date = doParseDate(dateFormatted)"
            @change="saveRdvDate">
          </v-date-picker>
        </v-menu>
        <v-menu
          ref="menuTime"
          v-model="menuTime"
          :close-on-content-click="false"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              ref="timeField"
              v-model="form.rdvHour"
              :label="$t('rdvStep.hour')"
              prepend-icon="mdi-clock"
              readonly
              filled
              v-bind="attrs"
              v-on="on"
              :rules="[rules.required, validateRangeTime]"
              class="required"></v-text-field>
          </template>
          <v-time-picker
            v-if="menuTime"
            v-model="form.rdvHour"
            :allowed-minutes="allowedStep"
            format="24hr"
            @click:minute="$refs.menuTime.save(time)"
            scrollable></v-time-picker>
        </v-menu>
        <v-select
          v-model="form.site"
          :items="sites"
          item-text="name"
          item-value="code"
          filled
          :label="$t('rdvStep.site')"
          :rules="[rules.required]"
          class="required" />
        <v-select
          v-model="form.reason"
          :items="rdvStepReasons"
          item-text="name"
          item-value="code"
          filled
          :label="$t('rdvStep.reason')"
          :rules="[rules.required]"
          class="required" />
        <v-radio-group
          :label="$t('rdvStep.accident')"
          v-model="form.accident"
          filled
          row
          class="required--radio"
          :rules="[rules.required]">
          <v-radio :label="$t('global.yes')" value="true"></v-radio>
          <v-radio :label="$t('global.no')" value="false"></v-radio>
        </v-radio-group>
      </v-form>
    </HfrCard>
  </v-container>
</template>
<script>
import HfrCard from '../ui/HfrCard.vue';
import { formatDate, parseDate } from '@/helpers/dates';
import { mapActions, mapState } from 'vuex';
import { requiredRule } from '@/helpers/validationRules';
export default {
  name: 'RdvStep',
  data() {
    return {
      form: {
        rdvDate:
          process.env.VUE_APP_PREFILL_FORMS === 'true' ? new Date().toISOString().slice(0, 10) : null,
        rdvHour: process.env.VUE_APP_PREFILL_FORMS === 'true' ? '13:00' : null,
        reason: process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'A' : null,
        accident: process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'false' : null
      },
      rules: {
        required: requiredRule
      },
      minDate: new Date().toISOString().slice(0, 10),
      stepNumber: 1,
      time: null,
      menuTime: false,
      menuDate: false,
      activeRdvDatePicker: null,
      rdvDateComplete: null,
    };
  },
  components: { HfrCard },
  watch: {
    navigateToNextStep: {
      handler(navigateToNextStep) {
        if (this.currentStep === this.stepNumber && navigateToNextStep) {
          this.validateRdvForm();
        }
      }
    },
    rdvDateComplete(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$refs.dateField.validate();
        this.$refs.timeField.validate();
      }
    }
  },
  methods: {
    ...mapActions('navigation', [
      'setFormValidity',
      'doNextStep',
      'toggleNavigateToNextStep'
    ]),
    ...mapActions('preAdmission', ['storeRdvStep']),
    allowedStep: (m) => m % 15 === 0,
    doParseDate(date) {
      return parseDate(date);
    },
    saveRdvDate(date) {
      this.$refs.menuDate.save(date);
    },
    validateRdvForm() {
      if (this.$refs.rdvForm.validate()) {
        this.storeRdvStep(this.form);
        this.doNextStep();
      }
      this.toggleNavigateToNextStep();
    },
    validateRangeDate() {
      return this.validateInAcceptance(this.form.rdvDate || '', this.form.rdvHour || '')
    },
    validateRangeTime() {
      return this.validateInAcceptance(this.form.rdvDate || '',  this.form.rdvHour || '')
    },
    validateInAcceptance(date, time) {
      if (time == '' || date == '') return true
      const [year, month, day] = date.split('-');
      const [hour, minute] = time.split(':')
      const selectedDate = new Date(year, month -1, day, hour, minute, 0);

      const minDate = new Date();
      minDate.setHours(minDate.getHours() + parseInt(process.env.VUE_APP_MIN_RDV_HOURS));

      const maxDate = new Date();
      maxDate.setMonth(maxDate.getMonth() + parseInt(process.env.VUE_APP_MAX_RDV_MONTHS));
      if (this.rdvDateComplete != selectedDate.getTime()) {
        this.rdvDateComplete = selectedDate.getTime();
      }
      if (minDate > selectedDate) {
        return this.$t('rdvStep.errors.minDate')
      }
      if (maxDate < selectedDate) {
        return this.$t('rdvStep.errors.maxDate')
      }
      return true
    }
  },
  computed: {
    ...mapState('preAdmission', ['sites', 'rdvStepReasons']),
    ...mapState('navigation', ['navigateToNextStep', 'currentStep']),
    formattedRdvDate: {
      get() {
        return formatDate(this.form.rdvDate);
      },
      set() {}
    }
  }
};
</script>
